module.exports = __webpack_public_path__ + "img/loading.3e9f27eb.gif";